import * as Yup from "yup";
import { getConfig } from "@root/config/config";

const strongPassword = (messageRequired) => {
  // eslint-disable-next-line max-len
  const message = 'Пароль должен содержать не менее 8 знаков, включать хотя бы одну заглавную латинскую букву, одну строчную, цифру и специальный символ';
  const messageNoSpaces = 'Пароль должен быть без пробелов';
  const messageInvalidChars = 'Используется недопустимый символ';

  const regexp = /^.*(?=.{8,})((?=.*[!@#$%^&*()_=+{}[\]:;"'<>,.?/\\|-]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
  const allowedCharsRegex = /^[A-Za-zА-Яа-яЁё0-9!@#$%^&*()_=+{}[\]:;"'<>,.?/\\|-]+$/;

  return Yup.string().min(1, messageRequired).max(100, 'Введите не более 100 символов')
    .matches(/^\S+$/, messageNoSpaces)
    .matches(allowedCharsRegex, messageInvalidChars)
    .matches(regexp, message);
};

export const passwordValidation = (messageRequired) =>
  getConfig().auth.passwordStrongValidation ? strongPassword(messageRequired) : Yup.string().required(messageRequired);
